import { capitalizeFirstLetter } from '../../utilities/services/capitalizeFirstLetter';
import './ClientFormsSummaryItem.css';
import { Link } from 'react-router-dom';

export default function ClientFormsSummaryItem({formItem}) {
    

  return (
    <tr className='ClientFormsSummaryItem'>
        <td className='projectNumber'>
            <Link to={`/forms/${formItem._id}`}>{formItem.projectNumber}</Link>
        </td>
        <td className='titleOfInvention'>
            {formItem.titleOfInvention? formItem.titleOfInvention:'---'}
        </td>
        <td className='service'>
            {formItem.service}
        </td>
        <td className='client'>
            <Link to={`/clients/${formItem.clientID}`}>{capitalizeFirstLetter(formItem.companyName)}</Link>
        </td>
        <td className='createdAt'>
            <div>
                {new Date(formItem.createdAt).toLocaleDateString('default', { month: 'short', day: 'numeric', year: 'numeric', timeZone: 'UTC' })}
            </div>
        </td>
        <td className='lastUpdate'>
            <div>
                {new Date(formItem.updatedAt).toLocaleDateString('default', { month: 'short', day: 'numeric', year: 'numeric', timeZone: 'UTC' })}
            </div>
        </td>
        <td className='formStatus'>
            <div className={`formStatusContainer ${formItem.status}`}>
                <div className={`statusColor ${formItem.status}`}></div>
                <div className='statusText'>
                    <strong>
                        {formItem.status === 'new' ? 'New' : formItem.status === 'inProgress' ? 'In Progress' : formItem.status === 'submitted' ? 'Submitted' : formItem.status === 'complete' ? 'Complete' : formItem.status === 'changesSubmitted' ? 'Changes Made' : formItem.status === 'changesApproved' ? 'Changes Approved' : formItem.status === 'changesRejected' ? 'Changes Rejected' : ''}
                    </strong>
                </div>
            </div>
        </td>
        <td className='submissionDate'>
            { formItem.submissionDate?
            <div>
                {new Date(formItem.submissionDate).toLocaleDateString('default', { month: 'short', day: 'numeric', year: 'numeric', timeZone: 'UTC' })}
            </div>
            :
            '---'
            }
        </td>
        <td className='approvalDate'>
            { formItem.approvalDate?
            <div>
                {new Date(formItem.approvalDate).toLocaleDateString('default', { month: 'short', day: 'numeric', year: 'numeric', timeZone: 'UTC' })}
            </div>
            :
            '---'
            }
        </td>
    </tr>
  )
}
